import { Injectable, inject } from '@angular/core';
import { Storage, ref, uploadBytesResumable, getDownloadURL } from '@angular/fire/storage';
import { Observable, Subject } from 'rxjs';
import { firstValueFrom } from 'rxjs';

import { DocumentService } from './document.service';
import { SimulationService } from './simulation.service';

import { Document, UploadFile } from 'src/app/models';
import { createNextStep } from 'src/app/utils/createNextStep';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class UploadService {
  basePath: string = 'documents';
  document: Document = {
    author: '',
    author_function: '',
    publication_date: 0,
    name: '',
    path: '',
  };

  private storage: Storage = inject(Storage);

  constructor(
    private documentService: DocumentService,
    private simulationService: SimulationService
  ) {}

  postFile(newStep: UploadFile, fechaLimite?: boolean, nroDias?: number): Observable<Document> {
    const subject = new Subject<Document>();

    const id = new Date().getTime();
    const fileName = `${id}${newStep.file.name}`;
    const filePath = `${this.basePath}/${newStep.simulationIdentifier}/${fileName}`;
    const storageRef = ref(this.storage, filePath);
    const uploadTask = uploadBytesResumable(storageRef, newStep.file);

    Swal.fire({
      title: 'Cargando archivo...',
      text: 'Por favor espere...',
      icon: 'info',
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    uploadTask.on('state_changed', null, (error) => subject.error(error), async () => {
      const downloadURL = await getDownloadURL(storageRef);
      this.document.path = downloadURL;
      this.document.name = newStep.file.name;
      this.document.author = newStep.user;
      this.document.author_function = newStep.userFunction;
      this.document.publication_date = Date.now();

      const docRef = await firstValueFrom(this.documentService.postDocument(this.document));
      const idDocument = docRef.id;

      this.documentService.getDocumentById(idDocument).subscribe((document: any) => {
        this.simulationService.getSimulation(newStep.simulationIdentifier).subscribe((result) => {
          result.steps?.forEach((step: any) => {
            if (step.name === newStep.step) {
              step.document = document.id;
              step.stop_date = Date.now();
            }
          });

          if (newStep.nextStep) {
            const nextStep = createNextStep(newStep.nextStep, fechaLimite, nroDias);
            result.steps?.push(nextStep);
          }

          this.simulationService.putSimulation(result);
          Swal.close();
          Swal.fire({
            title: '¡Listo!',
            text: 'El documento se subió correctamente',
            icon: 'success',
          });

          // Emit the saved document and complete
          document.publication_date = new Date(document.publication_date);
          subject.next(document);
          subject.complete();
        });
      });
    });

    return subject.asObservable();
  }

  postFile2(newStep: UploadFile, fechaLimite?: boolean, nroDias?: number): Observable<Document> {
    const subject = new Subject<Document>();

    const filePath = `${this.basePath}/${newStep.file.name}`;
    const storageRef = ref(this.storage, filePath);
    const uploadTask = uploadBytesResumable(storageRef, newStep.file);

    Swal.fire({
      title: 'Cargando archivo...',
      text: 'Por favor espere...',
      icon: 'info',
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    uploadTask.on('state_changed', null, (error) => subject.error(error), async () => {
      const downloadURL = await getDownloadURL(storageRef);
      this.document.path = downloadURL;
      this.document.name = newStep.file.name;
      this.document.author = newStep.user;
      this.document.author_function = newStep.userFunction;
      this.document.publication_date = Date.now();

      const docRef = await firstValueFrom(this.documentService.postDocument(this.document));
      const idDocument = docRef.id;

      this.documentService.getDocumentById(idDocument).subscribe((document: any) => {
        this.simulationService.getSimulation(newStep.simulationIdentifier).subscribe((result) => {
          result.steps?.forEach((step: any) => {
            if (step.name === newStep.step) {
              step.document2 = document.id;
              step.stop_date2 = Date.now();
            }
          });

          if (newStep.nextStep) {
            const nextStep = createNextStep(newStep.nextStep, fechaLimite, nroDias);
            result.steps?.push(nextStep);
          }

          this.simulationService.putSimulation(result);
          Swal.close();
          Swal.fire({
            title: '¡Listo!',
            text: 'El documento se subió correctamente',
            icon: 'success',
          });

          // Emit the saved document and complete
          document.publication_date = new Date(document.publication_date);
          subject.next(document);
          subject.complete();
        });
      });
    });

    return subject.asObservable();
  }
}
